module.exports = __webpack_public_path__ + "img/caution.be7d38e6.png";